module.exports = __webpack_public_path__ + "web/img/level-4.b330f509.png";